import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/NotFound'
import Main from '@/components/Main'
import Sf from '@/components/menu/layouts/Sf'
import Sunnyfactory from '@/components/menu/Sunnyfactory'
import Portfolio from '@/components/menu/Portfolio'
import ContactUs from '@/components/menu/ContactUs'

Vue.use(Router)

export default new Router({
  mode:'history' ,
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main
    },
    { path: '/404',
      component: NotFound
    },
    { path: '*',
      redirect: '/404'
    },
    { path: '/sf/:id',
      component : Sf ,
      props : true
    },
  ],
  beforeEach (to , from , next) {
    console.log(to);
    console.log(from);
    console.log(next);
  },
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js